import { ReleaseFormType } from '@api'

export const isDocumentType = (type: string) => {
  return [
    ReleaseFormType.LINK,
    ReleaseFormType.UNKNOWN,
    ReleaseFormType.DOCUMENT,
  ].some((t) => t.toLowerCase() === type.toLowerCase())
}

export const isGuestType = (type: string) => {
  return type.toLowerCase() === ReleaseFormType.GUEST.toLowerCase()
}

export const isUserType = (type: string) => {
  return type.toLowerCase() === ReleaseFormType.USER.toLowerCase()
}
